export default "/images/vendor/flag-icon-css/flags/1x1/sc.svg?8357ba15f90dbaaeec2a8b5ab44fdfad";